import http from "@/utils/request";

export default {
  homePage: function () {
    const url = `/home-page`;
    return http.get(url);
  },
};
